import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const UserMenu: React.FC = () => {
  const { logout, user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleNavigation = (path: string) => {
    navigate(path);
    setIsOpen(false);
  };

  const handleLogout = () => {
    logout();
    setIsOpen(false);
    navigate('/login');
  };

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button
        className="user-menu-trigger"
        onClick={() => setIsOpen(prev => !prev)}
        aria-label={
          isAuthenticated && user
            ? 'Open user menu'
            : 'Open guest menu'
        }
        aria-expanded={isOpen}
      >
        <div className="user-avatar">
          {isAuthenticated && user
            ? user.name
              ? getInitials(user.name)
              : '👤'
            : 'G'}
        </div>
      </button>

      {isOpen && (
        <div className="user-dropdown">

          {isAuthenticated && user ? (
            <>
              {/* USER INFORMATION */}
              <div className="dropdown-header">
                <div className="dropdown-info">
                  <div className="dropdown-name">
                    {user.name}
                  </div>

                  <div className="dropdown-email">
                    {user.email || user.phone || ''}
                  </div>
                </div>
              </div>

              <div className="dropdown-divider"></div>

              {/* PROFILE */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/profile')}
              >
                <span>👤</span>
                Profile
              </button>

              {/* MY ORDERS */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/my-orders')}
              >
                <span>📦</span>
                My Orders
              </button>

              {/* POINTS HISTORY */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/points-history')}
              >
                <span>⭐</span>
                Points History
              </button>

              {/* WISHLIST */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/wishlist')}
              >
                <span>❤️</span>
                Wishlist
              </button>

              <div className="dropdown-divider"></div>

              {/* PRIVACY POLICY */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/privacy')}
              >
                <span>🔒</span>
                Privacy Policy
              </button>

              {/* ABOUT US */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/about')}
              >
                <span>🏪</span>
                About Us
              </button>

              <div className="dropdown-divider"></div>

              {/* LOGOUT */}
              <button
                className="dropdown-item logout-item"
                onClick={handleLogout}
              >
                <span>🚪</span>
                Logout
              </button>
            </>
          ) : (
            <>
              {/* GUEST INFORMATION */}
              <div className="dropdown-header">
                <div className="dropdown-info">
                  <div className="dropdown-name">
                    Guest
                  </div>

                  <div className="dropdown-email">
                    Welcome to Gimbiya Value Store
                  </div>
                </div>
              </div>

              <div className="dropdown-divider"></div>

              {/* LOGIN */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/login')}
              >
                <span>🔐</span>
                Login
              </button>

              {/* CREATE ACCOUNT */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/register')}
              >
                <span>👤</span>
                Create Account
              </button>

              <div className="dropdown-divider"></div>

              {/* PRIVACY POLICY */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/privacy')}
              >
                <span>🔒</span>
                Privacy Policy
              </button>

              {/* ABOUT US */}
              <button
                className="dropdown-item"
                onClick={() => handleNavigation('/about')}
              >
                <span>🏪</span>
                About Us
              </button>
            </>
          )}

        </div>
      )}
    </div>
  );
};

export default UserMenu;